// Feature-flagged embedding of the CDN-hosted GENERIC chat widget into the
// first-party portal. This is a bring-up trial: it loads the exact same
// widget.js a partner would consume (served from the partner CDN) and drives it
// with a host transport against our SAME-ORIGIN foundry chat endpoints — proving
// the "CDN artifact + host transport" contract end to end before we hand it to a
// partner team.
//
// Additive + default OFF. The built-in <ChatWidget/> is unchanged when this is
// off. Toggle sources (highest precedence first):
//   1. URL query `?cdnWidget=1` (force on) / `?cdnWidget=0` (force off) — lets us
//      flip it per page load in the author portal WITHOUT a rebuild/redeploy.
//   2. Build-time `VITE_CDN_WIDGET_ENABLED=true`.
// The widget URL defaults to the AUTHOR CDN endpoint; override per environment
// with `VITE_CDN_WIDGET_URL` (a production build MUST point at its own channel).
// For LOCAL iteration the DEV default is a SAME-ORIGIN path — copy the freshly
// built widget into the dev server's public dir so Vite serves it at /cmsp-widget/:
//   cd partner/widget && npm run build
//   Copy dist/widget.js + dist/widget.css into ClientApp/public/cmsp-widget/
// (that folder is gitignored). Set VITE_CDN_WIDGET_URL to override either default.

const DEFAULT_CDN_WIDGET_URL =
  'https://cmsp-author-ai-partners-fabud5gqbqddgpge.b01.azurefd.net/partners/generic/latest/widget.js';

/** Same-origin dev default: the locally-built widget copied into public/cmsp-widget/. */
const DEV_CDN_WIDGET_URL = '/cmsp-widget/widget.js';

export const cdnWidgetUrl: string =
  (import.meta.env.VITE_CDN_WIDGET_URL as string | undefined)?.trim() ||
  (import.meta.env.DEV ? DEV_CDN_WIDGET_URL : DEFAULT_CDN_WIDGET_URL);

/** Resolve whether the CDN widget should replace the built-in chat for this load. */
export function isCdnWidgetEnabled(): boolean {
  try {
    const q = new URLSearchParams(window.location.search).get('cdnWidget');
    if (q === '1' || q === 'true') return true;
    if (q === '0' || q === 'false') return false;
  } catch {
    // Non-browser / malformed URL — fall through to the build-time flag.
  }
  return (import.meta.env.VITE_CDN_WIDGET_ENABLED as string | undefined) === 'true';
}
